import { render, staticRenderFns } from "./tableM.vue?vue&type=template&id=3a10a198&"
import script from "./tableM.vue?vue&type=script&lang=ts&"
export * from "./tableM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports